module.exports = __webpack_public_path__ + "static/media/4kmanzara.4d0fb49d.webp";